import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { useCommonData } from '../../../common-data/useCommonData';
import { getOrderedSiteSections } from '../../../navigation/getOrderedSiteSections';
import { Responsive } from '../../../ui';
import { getHomePageUrl } from '../../../navigation/getHomePageUrl';
import { getCurrentAirportCodeFromId } from './utils/getCurrentAirportCode';

const MobileNavigation = dynamic(() => import('./mobile/MobileNavigation'), {
	ssr: false,
});
const DesktopNavigation = dynamic(() => import('./desktop/DesktopNavigation'), {
	ssr: false,
});

interface IProps {
	siteSectionId?: string;
	isSticky: boolean;
}

export default function Navigation({ siteSectionId, isSticky }: IProps) {
	const { siteSections } = useCommonData();
	const isTablet = !!Responsive.useMatchesBreakpoint('tablet');
	const orderedSiteSections = getOrderedSiteSections(siteSections);
	const [currentSiteSectionId, setCurrentSiteSectionId] =
		useState(siteSectionId);

	const currentSiteSection = siteSections.find(
		(section) => section.fields.id === currentSiteSectionId,
	);

	const currentAirportCode = getCurrentAirportCodeFromId(
		currentSiteSection?.fields.id,
	);
	const homeUrl = getHomePageUrl(currentAirportCode);

	if (isTablet) {
		return (
			<MobileNavigation
				siteSections={orderedSiteSections}
				onSiteSectionIdChange={setCurrentSiteSectionId}
				currentSiteSection={currentSiteSection}
				siteSectionId={siteSectionId}
				isSticky={isSticky}
				backgroundVariant="dark"
				homeUrl={homeUrl}
			/>
		);
	}

	return (
		<DesktopNavigation
			siteSections={orderedSiteSections}
			onSiteSectionIdChange={setCurrentSiteSectionId}
			currentSiteSection={currentSiteSection}
			siteSectionId={siteSectionId}
			isSticky={isSticky}
			homeUrl={homeUrl}
		/>
	);
}
